import { render, staticRenderFns } from "./defaultcontainer.vue?vue&type=template&id=1fed25ab&"
import script from "./defaultcontainer.vue?vue&type=script&lang=js&"
export * from "./defaultcontainer.vue?vue&type=script&lang=js&"
import style0 from "./defaultcontainer.vue?vue&type=style&index=0&id=1fed25ab&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports